import { ReactElement } from "react";
import { ILadleStatus } from "../../../../types";
import { Card, CardContent, Typography } from "@mui/material";
import { formatDateTimeWithSeconds } from "../../../../system/utils";
import KeyValueItem from "../../../../components/charts/keyValueItem";

interface ILadleStatusProps {
  ladleData: ILadleStatus;
}

const LadleStatus = ({ ladleData }: ILadleStatusProps): ReactElement => {

  return (
    <Card sx={{
      margin: "1em",
      minWidth: 275,
      maxWidth: 400,
    }}>
      <CardContent sx={{ padding: 0 }}>
        <div className="p-1" style={{ background: ladleData.color }}>
          <Typography variant="h5" className="text-center m-0">
            {ladleData.ladle}
          </Typography>
        </div>

        <div className="m-2 display-flex-column p-1">
          <KeyValueItem name="Counter" value={ladleData.counter} />
          <KeyValueItem name="Heats" value={ladleData.heats} />
          <KeyValueItem name="Maintenance" value={ladleData.maintenance ?? "---"} />
        </div>

        <div className="m-2 border-top display-flex-column  p-1">
          <strong className="text-center">{ladleData.machineName}</strong>
          <KeyValueItem name="Begin" value={formatDateTimeWithSeconds(ladleData.beginDatetime)} />
          <KeyValueItem name="End" value={formatDateTimeWithSeconds(ladleData.endDatetime)} />
          <KeyValueItem name="status" value={ladleData.status} />
          <KeyValueItem name="temperature" value={ladleData.temperature} />
          <KeyValueItem name="weight" value={ladleData.weight ?? "---"} />
        </div>
      </CardContent>
    </Card>
  );
};

export default LadleStatus;
